import React, { useContext } from 'react';
import * as Yup from 'yup';
import { OnboardingContext } from '../../../OnboardingContext';
import { AccountCreationForm } from '../AccountCreationForm';
import BasicInfoFields from './BasicInfoFields';

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  fianceFirstName: Yup.string().required("Partner's first name is required"),
  fianceLastName: Yup.string().required("Partner's last name is required"),
  weddingLocation: Yup.string().optional(),
  weddingDateTBA: Yup.boolean().optional(),
  weddingDate: Yup.string().when('weddingDateTBA', {
    is: true,
    then: Yup.string().notRequired(),
    otherwise: Yup.string().required('Wedding date is required'),
  }),
  searchable: Yup.boolean().optional(),
});

interface Props {
  basicInfoAltWrapperStyles?: String[];
}

export const BasicInfoForm: React.FC<Props> = ({ basicInfoAltWrapperStyles }) => {
  const { firstName, lastName, fianceFirstName, fianceLastName, isLoggedIn, weddingLocation, weddingDate } = useContext(
    OnboardingContext
  );
  const initialValues = {
    firstName: firstName || '',
    lastName: lastName || '',
    fianceFirstName: fianceFirstName || '',
    fianceLastName: fianceLastName || '',
    weddingLocation: weddingLocation || '',
    weddingDateTBA: false,
    weddingDate: weddingDate || '',
    searchable: true,
  };

  const shouldSignup = Boolean(isLoggedIn);

  return (
    <div className={basicInfoAltWrapperStyles?.join(',')}>
      <AccountCreationForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        Component={BasicInfoFields}
        shouldSignup={shouldSignup}
      />
    </div>
  );
};
